<template>
  <div>
    <PageName :title="`${isEdit ? 'Редактировать' : 'Создать'} карту лояльности`"/>
    <Form :value="card" @request="saveCard" class="create__card">
      <div class="create__card-form">
        <VInput name="cardNumber" required placeholder="Номер карты" />
        <VSelect
          required
          placeholder="Пользователь"
          name="user"
          :items="usersWithFIO"
          searchSelect
          users
          :value="userWithFIO"
        >
          <template slot="item" slot-scope="{ item }">
            <AccountBadge :user="item" />
          </template>
        </VSelect>
        <VInput name="transporter" placeholder="Перевозчик" />
      </div>
      <div>
        <Button
            :loading="saveLoading"
            width="228px"
            height="48px"
            :text="isEdit ? 'Сохранить' : 'Создать'"
            class="btn-primary"
        />
        <Button
            @click.native.prevent="$router.go(-1)"
            width="228px"
            height="48px"
            text="Отменить"
            class="btn-secondary"
            style="margin-top: 12px"
        />
      </div>
    </Form>
  </div>
</template>

<script>
import PageName from "@/components/PageName.vue";
import Form from "@/components/Form/Form";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import Button from "@/components/Button.vue";
import {createCard, getCard, updateCard} from "@/api/cards";
import { mapActions, mapGetters } from "vuex";
import VSelect from "@/components/Form/VSelect.vue";
import AccountBadge from "@/components/AccountBadge.vue";
import { FIO } from "@/utils/filters/stringFilters";

export default {
  name: "SaveCard",
  components: {
    PageName,
    Form,
    VInput,
    VSelect,
    AccountBadge,
    Button
  },
  props: {
    action: String
  },
  data(){
    return {
      card: {},
      cardLoading: true,
      id: null,
      saveLoading: false,
    }
  },
  async mounted() {
     if (this.isEdit) {
      this.id = parseInt(this.$route.params.id_card);
      await getCard(this.id).then(res => {
        this.card = {
          cardNumber: res.data.card_number,
          ...res.data
        }
      })
    }
  },
  computed: {
    ...mapGetters("users", ["usersWithFIO"]),

    isEdit() {
      return this.action === 'update'
    },
    isCreate() {
      return this.action === 'create'
    },
    userWithFIO() {
      if(this.card.user) return FIO(this.card.user.name, this.card.user.surname, this.card.user.patronymic)
      else return {}
    },
  },
  methods: {
    ...mapActions("cards", ["getCards"]),
    async saveCard(data) {
      const {
        cardNumber,
        user,
        transporter,
      } = data
      this.saveLoading = true;
      if (!this.isEdit) {
        await createCard(
          cardNumber,
          user ? user.id : null,
          transporter || '-'
        )
      } else {
        await updateCard(
            this.card.id,
            cardNumber,
            user ? user.id : null,
            transporter || '-'
        )
      }
      this.saveLoading = false
      this.getCards()
      this.$router.push({ name: "Cards" });
    },
  }
}
</script>

<style scoped lang="scss">
.create__card {
  flex-direction: row;
  gap: 15px;
  margin-top: 32px;

  .create__card-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 33px;
    padding: 48px 40px;
    row-gap: 12px;
    background: $light-gray;
    border-radius: 4px;
    width: 100%;
  }
}
</style>